import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import './InFormAlert.css';

export default function InFormAlert({openFlag, closeMethod, buttonMethod, titleText, contentText, buttonText = "OK"}) {
  return(
    <Dialog
      open={openFlag}
      onClose={closeMethod}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle className="dialog-title" id="alert-dialog-title">
        {titleText}
        {closeMethod !== null ?
        (<IconButton onClick={closeMethod}>
          <CloseIcon />
        </IconButton>)
        : null}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" style={{whiteSpace: 'pre-line'}}>
          {contentText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={buttonMethod} autoFocus>
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

InFormAlert.propTypes = {
  openFlag: PropTypes.bool,
  closeMethod: PropTypes.func,
  buttonMethod: PropTypes.func,
  titleText: PropTypes.string, 
  contentTExt: PropTypes.string, 
}